import { createContext } from "react";

export interface ContextType {
	entitiesSelected: string[];
	onSetEntities: (val: string[]) => void;
}

const defaultContextValues: ContextType = {
	entitiesSelected: [],
	onSetEntities: () => {}
};

export default createContext<ContextType>(defaultContextValues);
